<div *ngIf="(this.authService.userIsAuthenticated$ | async)?.token == null">
  <divisas-capital-tabla-precios></divisas-capital-tabla-precios>
</div>

<div *ngIf="(this.authService.userIsAuthenticated$ | async)?.token != null">
  <app-tabla-precios-auth></app-tabla-precios-auth>
</div>

<divisas-capital-promociones></divisas-capital-promociones>

<section class="bg-sucursal branches-section" id="branches">
    <div class="site-content">
    <div class="divisa-row">
      <div class="divisa-col-md-12 mx-auto">
        <app-home-branches></app-home-branches>
      </div>
    </div>
  </div>
</section>

<section class="home-banners-section">
  <app-home-banner></app-home-banner>
</section>

<divisas-capital-devices></divisas-capital-devices>
